/**
 * User: WangMeng
 * Date: 2018-07-16
 * Time: 16:55
 * Desc: 杜邦分析
 */

import styles from './duPont.scss';
import React, { PureComponent } from 'react';
import { Select, Spin } from 'antd';
import cns from 'classnames';
import { ReportDateTypeMonth, ReportDateTypeDay } from '../../../../constants/info';
import GroupBox from '../../../common/groupBox/GroupBox';
import { checkSearch, commonRequest } from '../../common/commons';
import {debounce} from '../../../../utils/debounce';
import { getOptions } from '../../../../services/financialPicture/index';
import { dupontAnalysis } from '../../../../services/financialPicture/riskAnalysis';
const Option = Select.Option;

export default class DuPoint extends PureComponent {
    constructor(props) {
        super(props);
        this.companyParam = checkSearch();
        const { reportYear, reportDateType } = this.companyParam;

        this.state = {
            dateOptions: [],
            loading: false,
            reportDate: `${reportYear}-${ReportDateTypeMonth[reportDateType]}-${ReportDateTypeDay[reportDateType]}`,
            data: {}
        };
    }

    componentDidMount() {
        this.getOptions();
        this.getData();
    }

    componentWillUnmount() {
        this.syncSearch.cancel();
    }

    getOptions = () => {
        getOptions({ companyCode: this.companyParam.companyCode }).then(data => {
            data = data || {};
            this.setState({ dateOptions: data.endDate || [] });
        });
    };

    syncSearch = debounce(() => {
        this.getData();
    }, 300);

    // 报告期改变
    searchChange = (reportDate) => {
        this.setState({
            reportDate
        }, () => {
            this.syncSearch();
        });
    };

    // 格式化时间
    formatParamByDate = () => {
        const { reportDate } = this.state;
        let arr = reportDate.split('-');
        let date = arr[0];
        let reportDateType = '';
        for(let k in ReportDateTypeMonth) {
            if(ReportDateTypeMonth[k] === arr[1]) {
                reportDateType = k;
                break;
            }
        }

        return { date, reportDateType };
    };

    getData = () => {
        this.setState({
            loading: true
        });

        dupontAnalysis(commonRequest(this.formatParamByDate())).then(data => {
            this.setState({
                loading: false,
                data: data || {}
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    render() {
        const { reportDate, dateOptions, data, loading } = this.state;

        return (
            <GroupBox id="risk-duPont" title="杜邦分析">
                <div className={cns('search-bar', styles.searchBar)}>
                    <label>报告期： </label>
                    <Select size="default" value={reportDate} onChange={this.searchChange}>
                        {
                            dateOptions.map(d => <Option value={d} key={d}>{d}</Option>)
                        }
                    </Select>
                </div>

                <Spin spinning={loading}>
                    <div className={styles.dopont}>
                        <div className={cns(styles.item, styles.first, styles.jzcsyl)}>
                            <p className={styles.name}>净资产收益率</p>
                            <p className={styles.value}>{data.a20}</p>
                        </div>
                        <div className={cns(styles.item, styles.second, styles.zcfzl)}>
                            <p className={styles.name}>资产负债率</p>
                            <p className={styles.value}>{data.assetLiabilityRatio}</p>
                        </div>
                        <div className={cns(styles.item, styles.second, styles.qycs)}>
                            <p className={styles.name}>权益乘数</p>
                            <p className={styles.value}>{data.equityMultiplier}</p>
                        </div>
                        <div className={cns(styles.item, styles.second, styles.zzcsyl)}>
                            <p className={styles.name}>总资产收益率</p>
                            <p className={styles.value}>{data.a19}</p>
                        </div>
                        <div className={cns(styles.item, styles.fzze)}>
                            <p className={styles.name}>负债总额</p>
                            <p className={styles.value}>{data.totliab}</p>
                        </div>
                        <div className={cns(styles.item, styles.zcze)}>
                            <p className={styles.name}>资产总额</p>
                            <p className={styles.value}>{data.totasset}</p>
                        </div>
                        <div className={cns(styles.item, styles.syzqyze)}>
                            <p className={styles.name}>所有者权益总额</p>
                            <p className={styles.value}>{data.righaggr}</p>
                        </div>
                        <div className={cns(styles.item, styles.zsjlv)}>
                            <p className={styles.name}>销售净利率</p>
                            <p className={styles.value}>{data.netprofitrate}</p>
                        </div>
                        <div className={cns(styles.item, styles.zzczzl)}>
                            <p className={styles.name}>总资产周转率</p>
                            <p className={styles.value}>{data.assetTurnover}</p>
                        </div>
                        <div className={cns(styles.item, styles.ldfz)}>
                            <p className={styles.name}>流动负债</p>
                            <p className={styles.value}>{data.totalcurrliab}</p>
                        </div>
                        <div className={cns(styles.item, styles.fldfz)}>
                            <p className={styles.name}>非流动负债</p>
                            <p className={styles.value}>{data.totalnoncliab}</p>
                        </div>
                        <div className={cns(styles.item, styles.ldzc)}>
                            <p className={styles.name}>流动资产</p>
                            <p className={styles.value}>{data.totcurrasset}</p>
                        </div>
                        <div className={cns(styles.item, styles.fldzc)}>
                            <p className={styles.name}>非流动资产</p>
                            <p className={styles.value}>{data.totalnoncassets}</p>
                        </div>
                        <div className={cns(styles.item, styles.jlr)}>
                            <p className={styles.name}>净利润</p>
                            <p className={styles.value}>{data.netprofit}</p>
                        </div>
                        <div className={cns(styles.item, styles.yyzsr)}>
                            <p className={styles.name}>营业总收入</p>
                            <p className={styles.value}>{data.bizinco}</p>
                        </div>
                        <div className={cns(styles.item, styles.hbzj)}>
                            <p className={styles.name}>货币资金</p>
                            <p className={styles.value}>{data.curfds}</p>
                        </div>
                        <div className={cns(styles.item, styles.yyzsr2)}>
                            <p className={styles.name}>营业总收入</p>
                            <p className={styles.value}>{data.bizinco}</p>
                        </div>
                        <div className={cns(styles.item, styles.yszk)}>
                            <p className={styles.name}>应收账款</p>
                            <p className={styles.value}>{data.accorece}</p>
                        </div>
                        <div className={cns(styles.item, styles.zcb)}>
                            <p className={styles.name}>总成本</p>
                            <p className={styles.value}>{data.totalCost}</p>
                        </div>
                        <div className={cns(styles.item, styles.yycb)}>
                            <p className={styles.name}>营业成本</p>
                            <p className={styles.value}>{data.bizcost}</p>
                        </div>
                        <div className={cns(styles.item, styles.ch)}>
                            <p className={styles.name}>存货</p>
                            <p className={styles.value}>{data.inve}</p>
                        </div>
                        <div className={cns(styles.item, styles.qtlr)}>
                            <p className={styles.name}>其他利润</p>
                            <p className={styles.value}>{data.otherProfits}</p>
                        </div>
                        <div className={cns(styles.item, styles.xsfy)}>
                            <p className={styles.name}>销售费用</p>
                            <p className={styles.value}>{data.salesexpe}</p>
                        </div>
                        <div className={cns(styles.item, styles.sds)}>
                            <p className={styles.name}>所得税</p>
                            <p className={styles.value}>{data.incotaxexpe}</p>
                        </div>
                        <div className={cns(styles.item, styles.glfy)}>
                            <p className={styles.name}>管理费用</p>
                            <p className={styles.value}>{data.manaexpe}</p>
                        </div>
                        <div className={cns(styles.item, styles.cwfy)}>
                            <p className={styles.name}>财务费用</p>
                            <p className={styles.value}>{data.finexpe}</p>
                        </div>
                    </div>
                </Spin>

            </GroupBox>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialRiskAnalysis/subComponents/DuPont.jsx